import { useStore } from './store';
import { jwtDecode } from 'jwt-decode';

export type LoginResponse = {
    token: string;
    userName: string;
    agencyName: string;
}

export interface AuthStore {
    isAuthenticated: () => boolean;
    token?: string;
    login: (loginResponse: LoginResponse) => void;
    logout: () => void;
    authData: LoginResponse;
}

const useAuthStore = useStore<AuthStore>(
    'auth',
    true,
    (set, get) => ({
        login: (loginResponse: LoginResponse) => {
            console.log(loginResponse);
           return  set({ token: loginResponse.token, authData: loginResponse })
        },
        logout: () => {
            localStorage.clear();
            set({ token: undefined, authData: undefined })
            window.location.reload();
        },
        isAuthenticated: () => {
            const token = get().token;
            if (!token) {
                return false;
            }
            try {
                const decoded = jwtDecode(token);
                const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds since the epoch
                if (decoded.exp && decoded.exp > currentTime) {
                    return true;
                }
                return false;
            } catch (error) {
                console.error(`Error decoding token: ${error}`);
                return false;
            }
        },
        authData: {
            userName: '',
            agencyName: '',
            token: ''
        }
    })
);

export default useAuthStore;